// VNYL-1481 — was an inline <script> in layout/theme.liquid.
//
// It has to be an external `defer` file, not an inline block: all.js runs
// `jQuery36(document).ready(...)` at top level (assets/all.js:2577), and once
// jquery.min.js is deferred the only way to guarantee jQuery36 exists before
// all.js executes is to sit in the same defer queue, between jquery-migrate
// and all.js. An inline script cannot be deferred, and a DOMContentLoaded
// listener would run *after* all.js — too late.
window.jQuery36 = jQuery.noConflict();
